export const organizationKeys = {
  all: ["organization"] as const,
  detail: () => [...organizationKeys.all] as const,
};
